<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="w-full max-w-4xl rounded-xl bg-white p-6 shadow-xl">
    <div class="mb-1 flex items-start justify-between">
      <div>
        <h3 class="text-[17px] font-bold text-gray-900">
          {{
            (mode() === "package"
              ? isArabic()
                ? "تعبئة صنف"
                : "Package Item"
              : isArabic()
                ? "استلام صنف"
                : "Deliver Item") +
              " — " +
              productTitle()
          }}
        </h3>
        <p class="mt-0.5 text-[13px] text-gray-400">
          {{ isArabic() ? "الكمية المطلوبة:" : "Ordered Quantity:" }} {{ orderedQuantity() }}
        </p>
      </div>
      <button
        (click)="onCancelClick()"
        class="rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
        <app-cancel-icon />
      </button>
    </div>

    @if (showSubmitConfirm()) {
      <div
        class="my-3 flex items-center gap-2.5 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-[13px] font-medium text-amber-800">
        <svg
          class="shrink-0 text-amber-600"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
        <span>
          {{
            isArabic()
              ? "هل أنت متأكد من تأكيد تفاصيل التعبئة لهذا الصنف؟"
              : "Are you sure you want to submit the packaging details for this item?"
          }}
        </span>
      </div>
    }

    @if (validationError()) {
      <div class="my-3 rounded-lg border border-red-300 bg-red-50 px-4 py-2.5 text-[13px] font-medium text-red-600">
        {{ validationError() }}
      </div>
    }
    @if (submitError()) {
      <app-error [apiError]="submitError()" />
    }

    <div class="mt-4">
      @if (loadingReasons()) {
        <p class="py-8 text-center text-[13px] text-gray-400">{{ isArabic() ? "جاري التحميل..." : "Loading..." }}</p>
      } @else {
        <app-item-status-table
          [orderedQuantity]="orderedQuantity()"
          [notFulfilledRows]="notFulfilledRows()"
          [reasons]="reasons()"
          [fulfilledLabel]="fulfilledLabel()"
          [notFulfilledLabel]="notFulfilledLabel()"
          [disabled]="submitting()"
          (rowsChange)="onRowsChange($event)" />
      }
    </div>

    <div class="mt-6 flex justify-end gap-3">
      <button
        (click)="onCancelClick()"
        class="rounded-lg border border-gray-300 px-6 py-2 text-[13px] font-bold text-gray-600 transition-colors hover:bg-gray-50">
        {{ isArabic() ? "إلغاء" : "Cancel" }}
      </button>

      <app-submit-button type="primary" [disabled]="submitting()" (click)="onSubmitClick()">
        @if (submitting()) {
          {{ isArabic() ? "جاري الإرسال..." : "Submitting..." }}
        } @else {
          {{ isArabic() ? "إرسال" : "Submit" }}
        }
      </app-submit-button>
    </div>
  </div>
</div>

@if (showCancelConfirm()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="isArabic() ? 'تأكيد الإلغاء' : 'Confirm Cancel'"
    [description]="isArabic() ? 'هل أنت متأكد من الإلغاء؟' : 'Are you sure you want to cancel?'"
    [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onSubmit)="onConfirmCancel()"
    (onCancel)="showCancelConfirm.set(false)" />
}
